<template>
    <div id="browse">
        <Navi currentPage="6"></Navi>
        <div class="body_container main_context">
            <div class="breadcrumb_con">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Download</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="download_body">
                <div class="pcga-doc-h">Download
                </div>
                <div class="pcga-doc-p">All data used in the website can be downloaded for free, which includes phenotype-cell-gene association data, as well as GWAS (phenotype) and tissue/single-cell type metadata. 
                    The download links and file descriptions are listed in following tables.
                </div>
                <el-collapse v-model="activeCollapse1">
                    <el-collapse-item name="1">
                        <template slot="title">
                            <i class="header-icon el-icon-info"></i> Phenotye-Tissue/Cell type-Gene association data
                        </template>
                        <el-row>
                            <vxe-table
                                row-id="id"
                                :data="dataUrl"
                                scroll-y="{enabled: false}"
                                :merge-cells="dataMerge"
                                align="center"
                                border
                                style="font-family: Arial, Helvetica, sans-serif;color:#000000"
                            >
                                <vxe-table-column
                                    v-for="col in dataCols"
                                    :key="col.field"
                                    :field="col.field"
                                    :title="col.title"
                                    :width="col.width"
                                    :align="col.align"
                                    header-align="center"
                                ></vxe-table-column>
                                <vxe-table-column
                                field="file_name"
                                title="Download"
                                width="10%"
                            >
                                <template #default="{ row }">
                                    <el-button
                                        type="success"
                                        icon="el-icon-download"
                                        circle
                                        size="small"
                                        @click="goDownload(row.file_name)"
                                    ></el-button>
                                </template>
                            </vxe-table-column>
                            </vxe-table>
                        </el-row>
                    </el-collapse-item>

                    <el-collapse-item name="2">
                        <template slot="title">
                            <i class="header-icon el-icon-info"></i> Meta data
                        </template>
                        <el-row>
                            <vxe-table
                                row-id="file_name"
                                :data="metaUrl"
                                scroll-y="{enabled: false}"
                                :merge-cells="metaMerge"
                                align="center"
                                border
                                style="font-family: Arial, Helvetica, sans-serif;color:#000000"
                            >
                                <vxe-table-column
                                    v-for="col in metaCols"
                                    :key="col.field"
                                    :field="col.field"
                                    :title="col.title"
                                    :width="col.width"
                                    :align="col.align"
                                    header-align="center"
                                ></vxe-table-column>
                            <vxe-table-column
                                field="file_name"
                                title="Download"
                                width="10%"
                            >
                                <template #default="{ row }">
                                    <el-button
                                        type="success"
                                        icon="el-icon-download"
                                        circle
                                        size="small"
                                        @click="goDownload(row.file_name)"
                                    ></el-button>
                                </template>
                            </vxe-table-column>
                            </vxe-table>

                        </el-row>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <!-- <Doc :paras="paras"></Doc> -->

        <Footer></Footer>
    </div>
</template>

<script>
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import axios from "axios/dist/axios.min";
import { api_dir, goToResultPage } from "@/bus.js";


export default {
    name: 'browse',
    components: { Navi, Footer },
    data: function () {
        return {
            activeCollapse1: ['1', '2'],
            dataUrl: [
                { 'ref_rna': 'Human tissues', 'assoc': 'Phenotype-Gene association', 'file_name': 'gtex.phenotype_gene.tsv.gz', 'size': '', 'format': 'Tab-separated file', 
                'des': 'Each row records a association between a phenotype and a gene. Columns meaning: "phenotype", phenotype ID; "Gene", gene symbol; "#Var", variant number in gene;\
                "Group", group ID in conditional step; "ECSP", P-value of ECS; "CondiECSP", conditional P-value; "GeneScore", gene score in conditional step.' },
                { 'ref_rna': 'Human single cell types', 'assoc': 'Phenotype-Gene association', 'file_name': 'sc_hs.phenotype_gene.tsv.gz', 'size': '', 'format': '', 'des': '' },
                { 'ref_rna': 'Mouse single cell types', 'assoc': 'Phenotype-Gene association', 'file_name': 'sc_mm.phenotype_gene.tsv.gz', 'size': '', 'format': '', 'des': '' },
                { 'ref_rna': 'Human tissues', 'assoc': 'Phenotype-Tissue/Cell type association', 'file_name': 'gtex.phenotype_cell.tsv.gz', 'size': '', 'format': '', 
                'des': 'Row index represents tissue/single cell type ID and column represents phenotype ID. The value represents P-value of association between them.' },
                { 'ref_rna': 'Human single cell types', 'assoc': 'Phenotype-Tissue/Cell association', 'file_name': 'sc_hs.phenotype_cell.tsv.gz', 'size': '', 'format': '', 'des': '' },
                { 'ref_rna': 'Mouse single cell types', 'assoc': 'Phenotype-Tissue/Cell association', 'file_name': 'sc_mm.phenotype_cell.tsv.gz', 'size': '', 'format': '', 'des': '' },
                { 'ref_rna': 'Human tissues', 'assoc': 'Tissue/Cell selective expression of gene', 'file_name': 'gtex.cell_gene.tsv.gz', 'size': '', 'format': '', 
                'des': 'Row index represents gene symbol (provided by HGNC). Column index contains two parts, i.e., tissue/cell type ID and expression indexes (mean, SE, P-value and Z-score of selective expression \
                calculated by REZ). \
                For example, column index "Adipose-Subcutaneous.mean" represents the mean expression value of Adipose-Subcutaneous.' },
                { 'ref_rna': 'Human single cell types', 'assoc': 'Tissue/Cell selective expression of gene', 'file_name': 'sc_hs.cell_gene.tsv.gz', 'size': '', 'format': '', 'des': '' },
                { 'ref_rna': 'Mouse single cell types', 'assoc': 'Tissue/Cell selective expression of gene', 'file_name': 'sc_mm.cell_gene.tsv.gz', 'size': '', 'format': '', 'des': '' },
            ],
            dataMerge:[
                { row: 0, col: 0, rowspan: 3, colspan: 0 },
                { row: 3, col: 0, rowspan: 3, colspan: 0 },
                { row: 6, col: 0, rowspan: 3, colspan: 0 },
                { row: 0, col: 2, rowspan: 3, colspan: 0 },
                { row: 3, col: 2, rowspan: 3, colspan: 0 },
                { row: 6, col: 2, rowspan: 3, colspan: 0 },
            ],
            dataCols: [
                { field: 'assoc', title: 'Association type', width: '24%' ,align:'center'},
                { field: 'ref_rna', title: 'Reference tissue/single cell type dataset', width: '15%',align:'center' },
                { field: 'des', title: 'File Format', width: '32%',align:'left' },
                { field: 'file_name', title: 'File name', width: '19%' ,align:'center'},
                // { field: 'des', title: 'File Format', width: '30%' },
            ],
            metaUrl: [
                { 'type': 'Phenotype', 'file_name': 'phenotype.meta.tsv', 'des': 'Each row represents a GWAS. Colunm meaning: \
                "id", phenotype ID;	"causaldb_id", CAUSALdb ID;	"category", category of phenotype; "trait", phenotype name;	"mesh_term", MeSH term of phenotype provided by CAUSALdb; "mesh_id", MeSH ID; \
                	"sample_size", sample size of GWAS;	"n_case", case number; "n_control", control number;	"population", population; "pmid": PubMed ID; "doc", download URL.' },
                { 'type': 'Tissue/Cell type', 'file_name': 'cell_type.meta.tsv', 'des': 'Each row represents a tissue or single cell type. Colunm meaning: "type", reference tissue/cell types dataset ("gtex" represents human \
                 tissue dataset, "sc_hs" represents human single cell types, "sc_mm" represents mouse single cell types); "cell_type_id", tissue/cell type ID; "source", source organ of sample; "category_cell_type", \
                category of inferred cell type; "category_source", category of source organ.; "unique_organ", the unique organ name for unifying the organ names between bulk-cell and single-cell RNA-seq samples; \
                "unique_organ_category", the category of unique organ.'},
            ],
            metaCols: [
                { field: 'type', title: 'Type', width: '15%' ,align:'center'},
                { field: 'des', title: 'File Format', width: '60%',align:'left' },
                { field: 'file_name', title: 'File name', width: '15%',align:'center' },
            ],
            metaMerge:[]
        }
    },
    mounted: function () {

    },
    methods: {
        goDownload(f){
            axios
            .get(api_dir + "/api.php", {
                params: {'file_name':f,'action':'download'},
            })
            .then(function (response) {
                var res = JSON.parse(JSON.stringify(response.data));
                if(res.error_code==0){
                    window.location.href='static/resource/database/'+f;
                }
            })
            .catch(function (error) {
                console.log(error);
            })
        }
    }
}
</script>



<style>
.el-collapse-item__header{
    font-size: 16px;
    font-weight: 600;
}
.download_body{
    margin: 0px 20px;
}

</style>


// WEBPACK FOOTER //
// src/views/download.vue